import { z } from "zod";

export const getPartnerBankAccountInfoSchema = () => {
	return z.object({
		iban: z.string().nullish(),
		bic: z.string().nullish(),
		accountHolder: z.string(),
	});
};

export type PartnerBankAccountFormModel = z.infer<
	ReturnType<typeof getPartnerBankAccountInfoSchema>
>;
